//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'rb-store-locator-side-panel',
  props: {
    isSidePanelActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getCloseIcon() {
      return 'rb-store-locator-side-panel__close-icon common__icon common__icon--close-side-panel'
    },
  },
  watch: {
    isSidePanelActive(isActive) {
      if (isActive) {
        this.$refs.sidePanelCloseButton.focus()
      }
    },
  },
  methods: {
    onClosePanel() {
      this.$emit('sidePanelClosed')
    },
  },
}
